// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"afa432df","746":"fd19c96b","787":"3d07e803"}[chunkId] + ".chunk.js";
};